/* Bloc « Ingrédients & nutrition ».
   Chaque sous-bloc « Saveur » rend sa vignette + son panneau (contrainte Horizon :
   un bloc parent ne lit pas les settings de ses enfants). Ce composant regroupe
   les vignettes en haut, n'affiche qu'un panneau à la fois, et reporte la portion. */
(function () {
  if (customElements.get('nutrition-facts')) return;

  customElements.define(
    'nutrition-facts',
    class NutritionFacts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.nfInit === 'true') return;
        this.dataset.nfInit = 'true';

        var tabsHost = this.querySelector('[data-nf-tabs]');
        var flavors = Array.from(this.querySelectorAll('.nf-flavor'));
        if (!tabsHost || !flavors.length) return;

        var portion = this.getAttribute('data-portion') || '';
        var self = this;
        this.tabs = [];
        this.panels = [];

        flavors.forEach(function (flavor, i) {
          var tab = flavor.querySelector('.nutrition-facts__tab');
          var panel = flavor.querySelector('.nutrition-facts__panel');
          if (!tab || !panel) return;

          // Portion sous le titre du tableau
          var serving = panel.querySelector('[data-nf-portion]');
          if (serving) serving.textContent = portion;

          // Déplacer la vignette dans la barre du haut
          tabsHost.appendChild(tab);
          var idx = String(i);
          tab.dataset.nfIndex = idx;
          tab.setAttribute('role', 'tab');
          panel.dataset.nfIndex = idx;

          var active = i === 0;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          panel.hidden = !active;

          tab.addEventListener('click', function () { self.select(idx); });

          self.tabs.push(tab);
          self.panels.push(panel);
        });
      }

      select(index) {
        this.tabs.forEach(function (tab) {
          var active = tab.dataset.nfIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach(function (panel) {
          panel.hidden = panel.dataset.nfIndex !== index;
        });
      }
    }
  );
})();
